module.exports = __webpack_public_path__ + "static/media/icon-newsweek.a9f17f04.svg";